import './FloatingActionBar.scss';
import React, { ReactNode } from 'react';
import classNames from 'classnames';

interface FloatingActionBarProps {
  /** Left-hand label, typically a selection count. */
  label: ReactNode;
  /** Action buttons and any other trailing content. */
  children?: ReactNode;
  /** Extra class on the bar, e.g. for a horizontal offset. */
  className?: string;
}

export default function FloatingActionBar ({ label, children, className }: FloatingActionBarProps) {
  return (
    <div className={classNames('floating-action-bar', className)}>
      <span className='selection-count'>{label}</span>
      {children}
    </div>
  );
}
